import {get, writable} from 'svelte/store';
import {embeddedWebComponent} from 'Store/embedded/embeddedFlowStore';

export type Alert = {
  type: string;
  message: string;
  hide?: boolean;
};

const {subscribe, set, update} = writable<Alert[]>([]);

const removeAlert = (alert: Alert) => {
  update(existingAlerts => {
    existingAlerts.splice(existingAlerts.indexOf(alert), 1);
    return existingAlerts;
  });
};

const createAlerts = () => {
  const REMOVE_ALERT_TIMEOUT_MS = 5000;

  return {
    subscribe,
    add: (type: string, message: string, hide = true, scrollToTop = false) => {
      if (scrollToTop && !get(embeddedWebComponent))
        document.body.scrollIntoView({behavior: 'smooth'});

      const newAlert = {type, message, hide};

      update(existingAlerts => [...existingAlerts, newAlert]);

      if (hide === true) {
        setTimeout(() => removeAlert(newAlert), REMOVE_ALERT_TIMEOUT_MS);
      }
    },
    remove: removeAlert,
    reset: () => set([]),
  };
};

export const alerts = createAlerts();
